import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequest } from "@utils/http-util";
import { injectWorkflowId } from "@utils/parameter-injector";
import { AdvancedWorkflowDetailsConfiguration } from "@idw-types/data/workflow-details-configuration";

export const getWorkflowDetailsAxnRequest = async (
    workflowId: string,
): Promise<{ data: AdvancedWorkflowDetailsConfiguration, error: any }> => {
    const route = injectWorkflowId(apiRoutes.serviceConfiguration.workflowConfig.axn.workflow, workflowId);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};
